import { FdmPlugin } from "./plugins";

import * as _ from 'lodash'
var StateMachine = require('javascript-state-machine');

let globalProcesses = {
    fdm_create_new_app: {
        uid: 'fdm_create_new_app',
        label: 'Create new app!!',
        panels: {
            setup:{
                items:[
                    { type:'text-editor' },
                    { type:'button', value:'Save' }
                ]
            }
        },
    }
};

let globalPanelTemplates = {
    default: {
        blank: {
            header: {},
            items:[],
            footer: {}
        },
        setup: {
            header: {},
            items:[],
            footer: {}
        }
    },
    step: {
        blank: {
            header: { show:true },
        }
    }
};

export class FdmWorkflowBase {

    _type:string = null;
    _name:string = null;

    // base index of sub-items
    children:string = null;

    // type
    type:string = 'default';

    // category (process classification)
    category:string = 'default';

    // unique identifier for this segment
    uid:string = null;

    // unique identifier for the compounds of parent items
    id:string = ''; // blank
    
    // what are we called?
    label:string = '';

    // do we know who our parents are?
    parent:any = null;

    // generic properties
    props:any = {};

    // product produced
    product:any = null;

    // if we return a state up the chain
    returnState:any = null;

    // various config options
    config:any = {};
    defaults:any = {};

    visual:any = {
        state:SHOW
    };

    constructor ( input:any = null ) {
        this._type = this.constructor.name;
        this._name = input['label'] ? input['label'] : 'unknown';
        // console.log('CONSTRUCT', this.constructor.name, this, input );
    }

    transferInput ( input:any = null ) {
        
        let me = this;

        // enforce sub-types
        if ( input['parent'] && input.parent['type'] ) {
            if ( input.parent.type == 'steps' ) {
                input['type'] = 'step';
            }
        }

        // just assume no incoming config
        this.config = this.defaultConfig( input['type'] );

        let after = {};

        if ( input ) {
            Object.keys( input ).forEach ( key => {

                let test = me[key] ? true : false;

                // does the current process have one of these?
                if ( test ) {

                    let incoming = input[key];

                    if ( incoming instanceof Array ) {

                        // console.log ( '@@@ ['+me._type+':'+me._name+'] ARRAY', key, incoming );
                        incoming.forEach( e => {

                            if ( key == 'processes' ) { 
                                if ( ! after[key] ) {
                                    after[key] = [];
                                }
                                after[key].push(e);
                            }
                        });

                    } else
                    if ( incoming instanceof Object ) {

                        // console.log ( '@@@ ['+me._type+':'+me._name+'] OBJECT', key, incoming );
                        me[key] = incoming;

                    } else {

                        // console.log ( '@@@ ['+me._type+':'+me._name+'] OTHER', key, incoming );
                        me[key] = incoming;

                    }

                    /*
                    input[key].forEach( e => {

                        if ( key == 'processes' ) { 
                            if ( e['import'] ) {
                                e = this.importProcess ( e );
                            }
                            if ( e ) {
                                this[key].push ( new FdmProcess ( e ) );
                            }
                        }
                        // else  if ( idx == 'steps' ) { this[idx].push ( new FdmStep ( e ) ); }
                        // else  if ( idx == 'states' ) { this[idx].push ( new FdmState ( e ) ); }
                        // else  if ( idx == 'items' ) { this[idx].push ( new FdmItem ( e ) ); }
                        // else  if ( idx == 'conditions' ) { this[idx].push ( new FdmCondition ( e ) ); }
                    
                    });
                    */
                    
                } else {
                    // console.log ( '@@@ ['+me._type+':'+me._name+'] PROPS', key, input[key] );
                    this.props[key] = input[key];
                }
            });
        }

        // override defaults if they are declared
        [ 'type','uid','parent','label','category' ].forEach ( t => {
            if ( this.props[t] ) {
                me[t] = this.props[t];
            }
        });

        // if no UID, make one up
        if ( ! this.uid ) {
            this.uid = this.uuidv4();
        }

        // no (cascading) id? Make one 
        if ( ! this.id ) {
            if ( this.parent && this.parent.id ) {
                this.id = this.parent.id + '--' + this.uid;
            } else {
                this.id = this.uid;
            }
        }

        // enforce type if it's an app
        if ( this._type == 'FdmApp' ) {
            this.type = 'app';
        }

        // console.log ( '@@@ ['+me._type+':'+me._name+'] AFTER', after );
        if ( after ) {
            Object.keys(after).forEach ( key => {
                let items = after[key];
                items.forEach(e => {
                    if ( e['import'] ) {
                        e = this.importProcess ( e );
                    }
                    if ( e ) {
                        e['parent'] = me;
                        me[key].push ( new FdmProcess ( e ) );
                    }
                });
                
            });
        }
    }

    transferConfig () {
        Object.keys( this.defaults ).forEach ( k => {
            if ( this.config.hasOwnProperty(k) ) {
                // this.config[k] = this.defaults[k];
            } else {
                this.config[k] = this.defaults[k];
            }
        });
    }

    defaultConfig( type:string = null ) {
        // console.log ( ' &&& defaultConfig', type );
        return {};
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    toJSON() {

        let ret = {
            type: this.type,
            base: this.children,
            uid: this.uid
        };
        let items = [];
        let idx = this.children;

        Object.keys( this.props ).forEach ( p => {
            ret[p] = this.props[p];
        });

        if ( this[idx] ) {
            this[idx].forEach ( s => {
            items.push(s.toJSON());
            });
            ret[idx] = items;
        }
        return ret;
    }

    importProcess ( p:any ) {
        if ( p && p.import && globalProcesses[p.import] ) {
            return globalProcesses[p.import];
        }
        return null;
    }

    updateProduct ( product:any = null ) {
        // console.log ( ' UPDATED PRODUCT', product );
        this.product = product;
    }

}

export class FdmStateMachine {

    sm:any = null;

    state:any = null;

    parent:any = null;

    product:any = null;

    // null='indeterminate', 'success','failed','aborted'
    returnState:any = null;


    constructor(input:any = null, parent:any = null ) {

        // console.log ( '@@@ NEW FdmStateMachine()', input );

        let initialState = 'blank';
        if ( input && input.initialState ) {
            initialState = input.initialState;
        }

        let me = this;

        this.parent = parent;

        this.sm = new StateMachine({
            init: initialState,
            transitions: [
                { name: 'start', from: ['blank','failed','aborted'],  to: 'setup' },
                { name: 'delegate', from: 'setup',  to: 'delegated' },
                { name: 'queue', from: 'setup',  to: 'queued' },
                { name: 'process', from: 'queued', to: 'processing' },
                { name: 'fail', from:'processing', to:'failed' },
                { name: 'abort', from:'processing', to:'aborted' },
                { name: 'success', from:['processing','delegated'], to:'succeeded' },
                { name: 'cancel', from: ['queued','processing','delegated'],  to: 'aborted' },
                { name: 'end', from: ['failed','aborted','succeeded'],  to: 'blank' },
                { name: 'reset', from: ['setup','failed','aborted','succeeded'],  to: 'blank' },
                { name: 'again', from: ['failed','aborted'],  to: 'setup' },
            ],
            methods: {
                onFail: function(args) { me.failed(args); },
                onAbort: function(args) { me.aborted(args); },
                onSuccess: function(args) { me.succeeded(args); },
            }
        });

        this.state = this.sm.state;
    }   
    // open up the panel
    start(args) {
        // console.log('@@ start()',this.state);
        this.sm.start(args);
        this.state = this.sm.state;
    }
    cancel(args) {
        // console.log('@@ cancel()',this.state);
        this.sm.cancel(args);
        this.state = this.sm.state;
    }
    // close the panel
    end(args) {
        // console.log('@@ end()',this.state);
        this.sm.end(args);
        this.state = this.sm.state;
    }
    reset(args) {
        // console.log('@@ reset()',this.state);
        this.sm.reset(args);
        this.state = this.sm.state;
    }

    delegate(args) {
        // console.log('@@ delegate()',this.state);
        this.sm.delegate(args);
        this.state = this.sm.state;
    }
    // start a new session (and open the panel)
    queue(args) {
        // console.log('@@ queue()',this.state);
        this.sm.queue(args);
        this.state = this.sm.state;

        // wait for queue to be free here (some subscribe() or another)
        // faked through setTimeout

        setTimeout ( () => { this.process(args); }, 2000 );
    }
    process(args) {
        // console.log('@@ process()',this.state);
        this.sm.process(args);
        this.state = this.sm.state;

        // wait for processing to finish here
        // faked through setTimeout
        
        setTimeout ( ()=>{
            this.product = [ 'list','of','things' ];
            this.processSucceeded();
        }, 2000 );

    }

    
    processFailed() {
        console.log('@@ __ processFailed()',this.state);
        this.sm.fail();
        this.state = this.sm.state;
    }
    processAborted() {
        console.log('@@ __ processAborted()',this.state);
        this.sm.abort();
        this.state = this.sm.state;
    }
    processSucceeded() {
        console.log('@@ __ processSucceeded()',this.state);
        this.sm.success();
        this.state = this.sm.state;
    }
    failed(args) {
        console.log('@@ failed()',this.state);
        if ( this.parent ) {
            this.parent.returnState = 'failed';
        }
    }
    aborted(args) {
        console.log('@@ aborted()',this.state);
        if ( this.parent ) {
            this.parent.returnState = 'aborted';
        }
    }
    succeeded(args) {
        console.log('@@ succeeded()',this.state);
        if ( this.parent ) {
            this.parent.returnState = 'succeeded';
            this.parent.updateProduct( this.product );
        }
    }
    returning(args) {
        console.log('@@ returning()',this.state);
        this.sm.reset();
    }
}

const SHOW = true;
const HIDE = false;

export class FdmProcess extends FdmWorkflowBase {

    state:FdmStateMachine = null;
    processes:FdmProcess[] = [];

    constructor( input:any = null ) {
        super( input );
        // console.log('CONSTRUCT PROCESS', this.constructor.name, this, input );
        this.transferInput ( input );
        this.transferConfig (); 
        this.state = new FdmStateMachine(this.config, this );
    }

    defaultConfig( type:string = null ) {
        // console.log ( ' &&& defaultConfig', type );
        if ( type == 'step' ) {
            return {
                type:'step',
                canDelete: false,
                canShowHide: false,
                showWhenBlank: true,
                showState: true,
                showHeader: true,
                initialState:'setup',
                show: {
                    header:SHOW,
                    menu:HIDE,
                    path:HIDE,
                    content:SHOW,
                    footer:SHOW
                },
                hide: {
                    header:SHOW,
                    menu:HIDE,
                    path:HIDE,
                    content:HIDE,
                    footer:HIDE
                }
            };
        }
        
        return {
            type:'process',
            canDelete: false,
            canShowHide: false,
            showWhenBlank: false,
            showState: true,
            showHeader: true,
            initialState:'blank',
            show: {
                header:SHOW,
                menu:HIDE,
                path:HIDE,
                content:SHOW,
                footer:HIDE
            },
            hide: {
                header:HIDE,
                menu:HIDE,
                path:HIDE,
                content:HIDE,
                footer:HIDE
            }
        };
    }
}

export class FdmApp extends FdmWorkflowBase {
    
    state:FdmStateMachine = null;
    processes:FdmProcess[] = [];

    constructor( input:any = null ) {
        super( input );
        // console.log('CONSTRUCT APP', this.constructor.name, this, input );
        this.transferInput ( input );
        this.transferConfig (); 
        this.state = new FdmStateMachine(this.config, this );
    }

    defaultConfig( type:string = null ) {
        // console.log ( ' &&& defaultConfig', type );
        return {
            type:'app',
            canDelete: true,
            canShowHide: true,
            showWhenBlank: true,
            showState: true,
            showHeader: true,
            initialState:'setup',
            show: {
                header:SHOW,
                menu:SHOW,
                path:HIDE,
                content:SHOW,
                footer:HIDE
            },
            hide: {
                header:SHOW,
                menu:HIDE,
                path:HIDE,
                content:HIDE,
                footer:HIDE
            }
        };
    }
}

export class FdmStep extends FdmWorkflowBase {

    states:FdmState[] = [];

    model:any = {
    name: '',
    currentStep: null,
    };

    constructor( input:any = null ) {
        super( input );
        this.transferInput ( input );
    }
}

export class FdmState extends FdmWorkflowBase {
    static states:any = [
    { name: 'open', label: 'Open', default:true },
    { name: 'queued', label: 'In queue' },
    { name: 'processing', label: 'Processing' },
    { name: 'success', label: 'Success' },
    { name: 'failed', label: 'Failed' },
    { name: 'aborted', label: 'Aborted' },
    ];

    items:FdmItem[] = [];
    
    model:any = {
    name: '',
    currentState: null,
    };

    constructor( input:any = null ) {
        super( 'items' );
        this.transferInput ( input );
    }
}

export class FdmPanel extends FdmWorkflowBase {

    items:FdmItem[] = [];

    constructor( input:any = null ) {
        super( input );
        this.transferInput ( input );
    }
}

export class FdmItem extends FdmWorkflowBase {

    conditions:FdmCondition[] = [];

    constructor( input:any = null ) {
        super( input );
        this.transferInput ( input );
    }
}

export class FdmCondition extends FdmWorkflowBase {

    states:FdmState[] = [];

    constructor( input:any = null ) {
        super( input );
        this.transferInput ( input );
        this.type = 'condition';
    }
}


// a plugin controller controls plugins for a set of items (for example, a Scene, or a group of Transforms, or a collection of Photos [ie. the Photo Bucket])

export class AppController {

    defaultStates:any = [
        { name: 'open', label: 'Open', default:true },
        { name: 'queued', label: 'In queue' },
        { name: 'processing', label: 'Processing' },
        { name: 'success', label: 'Success' },
        { name: 'failed', label: 'Failed' },
        { name: 'aborted', label: 'Aborted' },
    ];

    config:any = {
        label: null,
        categories: [],
        filterByType: [],
        filterByFeature: [],
        createId: function ( item ) { return item.id }
    };

    cache:any = {};
    cacheDirty:boolean = false;

    show:boolean = false;
    showDebug:boolean = false;

    id:string = '';
    label:string = '';

    public countActive:number = 0;
    public countAvailable:number = 0;

    // plugins active through this controller
    activeApps:any = [];


    exampleWorkflow:any = {
        id: '34534534',
        label: 'Some workflow',
        states: [
        { name: 'open', label: 'Open', default:true },
        { name: 'queued', label: 'In queue' },
        { name: 'processing', label: 'Processing' },
        { name: 'success', label: 'Success' },
        { name: 'failed', label: 'Failed' },
        { name: 'aborted', label: 'Aborted' },
        ],
    };

    upload:any = {
        id:'567567',
        name:'upload',
        label: 'Upload your files',
        states: this.defaultStates,
    };

    // photogrammetry workflow example
    photogrammetry:any = {
        id: '34535646742',
        name:'photogrammetry',
        label: 'Photogrammetry',
        variables: [
        { name: 'have_gcps', label:'Have GCPs?' }
        ]
    };

    

    someProcess = {

        name:'some_process',

        // define our interface
        states: [ 'open', 'queue', 'processing', 'failed', 'aborted', 'success' ],

        // steps in our process (using only the interface / states above)
        steps:[
        { }
        ]
    };


    myApp:any = {

        // workflow is similar to an app; a collection of processes
        name:'MyMiniApp',

        states: [ ],

        state: {

        }

    };


    _config ( config:any = null ) {
        Object.keys(config).forEach(k => {
            if ( config[k] ) {
                this.config[k] = config[k];
            }
        });
    }

    constructor ( id:string, config:any = null ) {

        this.id = id;
        // if there's a config coming in, transfer each config item to this controller (doing this to always make sure there are defaults)
        if ( config ) {
            this._config(config);
        }
        if ( this.config.label ) {
            this.label = this.config.label;
        }
        
    }

    clearCache( itemId:any = null ) {
        if ( itemId ) {
            if ( this.cache[itemId] ) {
                delete this.cache[itemId];
            } else {
                this.createCache(itemId);
            }
            // console.log('cleared item cache', this.id, itemId );
            return;
        }
        this.cache = {};
        this.cacheDirty = false;
        // console.log('cleared whole cache', this.id );
    }

    createCache ( itemId:string ) {
        this.cache[itemId] = { 
            name:'',
            windowState:null,
        };
    }

    updateCategories ( categories:any = null ) {
        if ( categories ) {
            this.config['categories'] = categories;
        }
    }

    create ( appName:string, config:any ) {
        this.cache[appName] = new FdmApp ( config );
        this.cache[appName]['name'] = appName;

        // console.log('>>>>>> appController.create('+appName+')', this.cache[appName] );
        return this.cache[appName];
    }

    // removes AND deletes from an item
    delete ( appName:string ) {
        this.cache[appName].end();
        delete this.cache[appName];
    }

    listAll() {
        let ret = [];
        Object.keys ( this.cache ).forEach ( key => {
            ret.push( this.cache[key] );
        });
        return ret;
    }
}
